type Store = {
  id?: string | null;
  selectableByUser?: boolean;
  address?: { country_code?: string | null } | null;
  zip?: string | null;
  city?: string | null;
  address1?: string | null;
  name?: string | null;
  companyName?: string | null;
};

export function filterStoresByCountry<T extends Store>(
  stores: T[],
  customerCountryCode: string | undefined | null,
  isMerchant: boolean,
): T[] {
  if (isMerchant) return stores;
  if (!customerCountryCode) return stores;
  return stores.filter((s) => s.address?.country_code === customerCountryCode);
}

export function sortStoresByProximity<T extends Store>(
  stores: T[],
  customerZip: string | undefined | null,
): T[] {
  if (!customerZip) return stores;
  const prefix = customerZip.slice(0, 2);
  return [...stores].sort((a, b) => {
    const aClose = (a.zip ?? "").startsWith(prefix) ? -1 : 0;
    const bClose = (b.zip ?? "").startsWith(prefix) ? -1 : 0;
    return aClose - bClose;
  });
}

export function searchStores<T extends Store>(stores: T[], query: string): T[] {
  if (!query.trim()) return stores;
  const q = query.toLowerCase();
  return stores.filter((s) => {
    const haystack = [s.zip, s.city, s.address1, s.name, s.companyName]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return haystack.includes(q);
  });
}
